// phoneFormat.js
//
// As-you-type US phone formatting — (555) 123-4567 — so every phone field in the app looks
// consistent without the person typing it having to add their own parentheses/dashes. Purely
// cosmetic: strips to digits and reformats on every keystroke, doesn't validate length or
// reject non-US formats (a technician entering a shorter or international number just gets
// partial formatting rather than being blocked).
export const formatPhoneNumber = (value) => {
  const digits = (value || '').replace(/\D/g, '');
  const len = digits.length;
  if (len === 0) return '';
  if (len < 4) return `(${digits}`;
  if (len < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  if (len <= 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  // Longer than a US number (a country code prefix, or a genuinely longer international number)
  // — keep the same (xxx) xxx-xxxx shape for the first 10 digits and append whatever follows,
  // rather than a hard slice(0, 10) that used to silently throw those extra digits away.
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}${digits.slice(10)}`;
};

// Drop-in replacement for a plain onChange={handleInputChange} handler on any phone <input> —
// formats the value before it ever reaches form state, so every reader of that state (save,
// preview, validation) sees the same formatted string the field displays. `setFormData` is
// passed in rather than imported, since every form in this app manages its own local state.
export const handlePhoneChange = (e, setFormData) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: formatPhoneNumber(value) }));
};
